import { IApplicationState } from '../../types/redux';
import { getUser, getUserRole } from '../user';

export const getIsRealtor = (state: IApplicationState): boolean =>
  Boolean(getUser(state) && getUserRole(state) === 'specialist');
